let _ = t => t,
  _t;
import styled, { css } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import breakpoint, { trellisBreakpoint } from 'ui-addon-upgrades/_core/utils/responsiveBreakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBadge = styled(Badge)(({
  theme
}) => ({
  margin: `${theme.space['0']} auto`,
  width: 'fit-content',
  marginBlockEnd: theme.space['200']
}));
export const FeatureTableBadge = ({
  use = 'new',
  badgeType
}) => {
  return /*#__PURE__*/_jsx(StyledBadge, {
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: badgeType === 'recommended' ? `upgrades.featureTable.badges.recommended` : `upgrades.featureTable.badges.currentPlan`
    })
  });
};
export const paddingLeft = css(["padding-left:42px;", ""], breakpoint.tablet(_t || (_t = _`
    padding-left: 16px;
    `)));
export const rowHeaderStyles = css(["text-align:left;", ""], paddingLeft);
export const foundationsPaddingLeft = ({
  theme
}) => ({
  paddingLeft: theme.space['1000'],
  [trellisBreakpoint.tablet]: {
    paddingLeft: theme.space['400']
  }
});
export const foundationsRowHeaderStyles = () => Object.assign({
  textAlign: 'left'
}, foundationsPaddingLeft);